<script setup lang="ts">
import SimpleButton from "@/components/ui/SimpleButton.vue";

const props = defineProps<{
  close: (result: unknown) => void;
  cancel: () => void;
}>();

const explanations = defineModel<string[]>("explanations", { required: true });
</script>

<template>
  <SimpleButton @click="props.cancel" label="Cancel" kind="ghost" />
  <SimpleButton @click="props.close(explanations)" label="Confirm" kind="primary" />
</template>

<style scoped>
.skore-button {
  flex-grow: 1;
}
</style>
